import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

const ValueContainer = ({ children, selectProps, ...props }) => (
  <components.ValueContainer {...props}>
    <div className='flex-container row wrap align-center' data-desc={`select__${selectProps.input.name}_value`}>
      {children}
    </div>
  </components.ValueContainer>
);

ValueContainer.defaultProps = {
  children: null
};

ValueContainer.propTypes = {
  children: PropTypes.any,
  selectProps: PropTypes.any.isRequired
};

export default ValueContainer;
